import {ModuleWithProviders, NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchComponent } from './search/search.component';
import { searchRoutes } from './search.routes';
import {RouterModule} from '@angular/router';
import {SearchService} from './search.service';
import { ModulesearchresultComponent } from './modulesearchresult/modulesearchresult.component';
import { SearchresultlistitemComponent } from './searchresultlistitem/searchresultlistitem.component';
import {SharedModule} from '../shared/shared.module';

const routing: ModuleWithProviders = RouterModule.forRoot(searchRoutes);
@NgModule({
  imports: [
    CommonModule,
      SharedModule,
      routing
  ],
  declarations: [SearchComponent, ModulesearchresultComponent, SearchresultlistitemComponent],
    providers: [SearchService]
})
export class SearchModule { }



// WEBPACK FOOTER //
// ./src/app/search/search.module.ts